import React from 'react';
import { Button, MainLayout, Triptych } from '@app/components';
import { CatalogHeader } from '@app/features/Catalog';
import { ConnectorCreate, ConnectorList, ConnectorUpdate } from '@app/features/Connector';
import { useResourceScreenHelpers } from '@app/hooks';
import { connectorApi } from '@app/store';
import { IConnector } from '@app/common';
import { CheckPermissions } from '@app/components/CheckPermissions';

export const ConnectorScreen = () => {
  const [readOne, { isFetching }] = connectorApi.useLazyReadOneConnectorsQuery();

  const { triptych, onUpdate, mode, selectedItem, item: connector } = useResourceScreenHelpers<IConnector>();

  const openCard = async (item: Partial<IConnector>) => {
    onUpdate(readOne({
      filters: { _id: { $eq: item?._id } },
    }), item);
  }

  return (
    <MainLayout
      header={(
        <CatalogHeader>
          <CheckPermissions permissions={['dashboard::connectors.create']}>
            <Button
              onPress={() => triptych.open({ mode: 'CREATE' })}
              title='Ajouter un connecteur' />
          </CheckPermissions>
        </CatalogHeader>
      )}>

      <Triptych
        list={(
          <ConnectorList
            selectedRowItem={selectedItem}
            onRowPress={(item) => triptych.close({ data: item, mode: 'UPDATE' })}
            onUpdate={openCard} />
        )}
        form={(
          mode === 'CREATE'
            ? <ConnectorCreate
              toggle={() => triptych.close()} />
            : <ConnectorUpdate
              connector={connector ?? selectedItem}
              toggle={(mode) => mode === 'UPDATE' ? openCard(selectedItem) : triptych.close()}
              isFetching={isFetching} />
        )} />
    </MainLayout>
  );
};
